/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UnauthorizedIndexRouteImport } from './routes/unauthorized/index'
import { Route as PoliciesIndexRouteImport } from './routes/policies/index'
import { Route as DocumentsIndexRouteImport } from './routes/documents/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as ClaimsIndexRouteImport } from './routes/claims/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedIndexRoute = UnauthorizedIndexRouteImport.update({
  id: '/unauthorized/',
  path: '/unauthorized/',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesIndexRoute = PoliciesIndexRouteImport.update({
  id: '/policies/',
  path: '/policies/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsIndexRoute = DocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClaimsIndexRoute = ClaimsIndexRouteImport.update({
  id: '/claims/',
  path: '/claims/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/claims': typeof ClaimsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/documents': typeof DocumentsIndexRoute
  '/policies': typeof PoliciesIndexRoute
  '/unauthorized': typeof UnauthorizedIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/claims': typeof ClaimsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/documents': typeof DocumentsIndexRoute
  '/policies': typeof PoliciesIndexRoute
  '/unauthorized': typeof UnauthorizedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/claims/': typeof ClaimsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/policies/': typeof PoliciesIndexRoute
  '/unauthorized/': typeof UnauthorizedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/claims'
    | '/dashboard'
    | '/documents'
    | '/policies'
    | '/unauthorized'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/claims'
    | '/dashboard'
    | '/documents'
    | '/policies'
    | '/unauthorized'
  id:
    | '__root__'
    | '/'
    | '/claims/'
    | '/dashboard/'
    | '/documents/'
    | '/policies/'
    | '/unauthorized/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClaimsIndexRoute: typeof ClaimsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DocumentsIndexRoute: typeof DocumentsIndexRoute
  PoliciesIndexRoute: typeof PoliciesIndexRoute
  UnauthorizedIndexRoute: typeof UnauthorizedIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized/': {
      id: '/unauthorized/'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policies/': {
      id: '/policies/'
      path: '/policies'
      fullPath: '/policies'
      preLoaderRoute: typeof PoliciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/': {
      id: '/documents/'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/claims/': {
      id: '/claims/'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof ClaimsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClaimsIndexRoute: ClaimsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DocumentsIndexRoute: DocumentsIndexRoute,
  PoliciesIndexRoute: PoliciesIndexRoute,
  UnauthorizedIndexRoute: UnauthorizedIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
